interface StatCardProps {
  title: string;
  value: string | number;
  icon: React.ReactNode;
  trend?: {
    value: string;
    isPositive: boolean;
  };
  color?: 'peacock' | 'phoenix' | 'critical' | 'amber' | 'mint';
}

function StatCard({ title, value, icon, trend, color = 'peacock' }: StatCardProps) {
  const colorGradients = {
    peacock: 'linear-gradient(135deg, var(--color-primary-500) 0%, var(--color-primary-600) 100%)',
    phoenix: 'linear-gradient(135deg, var(--color-accent-500) 0%, var(--color-accent-600) 100%)',
    critical: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
    amber: 'linear-gradient(135deg, #d97706 0%, #b45309 100%)',
    mint: 'linear-gradient(135deg, #5fcaab 0%, #059669 100%)',
  };

  return (
    <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all p-6 border border-gray-100">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
          <p className="text-3xl font-bold text-gray-900">{value}</p>
          {trend && (
            <div className={`mt-2 flex items-center text-sm ${trend.isPositive ? 'text-green-600' : 'text-red-600'}`}>
              <svg className={`w-4 h-4 mr-1 ${trend.isPositive ? '' : 'transform rotate-180'}`} fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z" clipRule="evenodd" />
              </svg>
              {trend.value}
            </div>
          )}
        </div>
        <div
          className="w-14 h-14 rounded-xl flex items-center justify-center shadow-lg"
          style={{ background: colorGradients[color] }}
        >
          <div className="text-white">
            {icon}
          </div>
        </div>
      </div>
    </div>
  );
}

interface QuickStatsProps {
  stats: Array<{
    title: string;
    value: string | number;
    icon: React.ReactNode;
    trend?: {
      value: string;
      isPositive: boolean;
    };
    color?: 'peacock' | 'phoenix' | 'critical' | 'amber' | 'mint';
  }>;
}

export default function QuickStats({ stats }: QuickStatsProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {stats.map((stat, index) => (
        <StatCard key={index} {...stat} />
      ))}
    </div>
  );
}
